import { c as _c } from "react/compiler-runtime";
import { Button, Text } from '@chakra-ui/react';
import { DiagnosticColumns } from '@src/components/sco/PitchDeck/PitchDeckLandingDiagnostic/DiagnosticShell';
import { AccentHeading, Panel, ProofStats, UPLOAD_OUTCOMES, WhyWeAsk } from '@src/components/sco/PitchDeck/PitchDeckLandingDiagnostic/shared';
import { useCommitPitchDeckDiagnostic } from '@src/components/sco/PitchDeck/PitchDeckLandingDiagnostic/useCommitPitchDeckDiagnostic';
import { DeckUploadCard } from '@src/components/sco/RequestFunnel/PitchDeckAudit/components/DeckUploadCard';
import { PitchDeckAuditAdditionalFields } from '@src/components/sco/RequestFunnel/PitchDeckAudit/types';
import { useRequestFunnelContext } from '@src/components/sco/RequestFunnel/RequestFunnelContext';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import tracker from '@src/lib/tracker';
import React, { useEffect } from 'react';
import { LuChevronRight } from 'react-icons/lu';
export const UploadStep: React.FC = () => {
  const $ = _c(35);
  const {
    currentUser,
    currentUserLoading
  } = useCurrentUser();
  const {
    saveSignupRequest,
    setStep,
    signupRequest,
    updateSignupRequest
  } = useRequestFunnelContext();
  const {
    busy,
    commitAndOpenDeck,
    error
  } = useCommitPitchDeckDiagnostic();
  let t0;
  if ($[0] !== signupRequest.additionalFields) {
    t0 = signupRequest.additionalFields || {};
    $[0] = signupRequest.additionalFields;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const additionalFields = t0;
  const storedFileId = additionalFields.deckStoredFileId;
  const hasDeck = !!signupRequest.pitchDeckUrl || !!storedFileId;
  let t1;
  if ($[2] !== additionalFields.deckFileName || $[3] !== signupRequest.pitchDeckUrl) {
    t1 = signupRequest.pitchDeckUrl ? additionalFields.deckFileName ?? decodeURIComponent(signupRequest.pitchDeckUrl.split("/").pop() ?? "") : null;
    $[2] = additionalFields.deckFileName;
    $[3] = signupRequest.pitchDeckUrl;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const fileLabel = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(_temp, t2);
  let t3;
  if ($[6] !== commitAndOpenDeck || $[7] !== currentUser?.isRegistered || $[8] !== currentUserLoading || $[9] !== saveSignupRequest || $[10] !== setStep || $[11] !== signupRequest.pitchDeckUrl || $[12] !== storedFileId) {
    t3 = () => {
      if (currentUserLoading) {
        return;
      }
      if (currentUser?.isRegistered && (signupRequest.pitchDeckUrl || storedFileId)) {
        commitAndOpenDeck();
        return;
      }
      saveSignupRequest(() => setStep("register"));
    };
    $[6] = commitAndOpenDeck;
    $[7] = currentUser?.isRegistered;
    $[8] = currentUserLoading;
    $[9] = saveSignupRequest;
    $[10] = setStep;
    $[11] = signupRequest.pitchDeckUrl;
    $[12] = storedFileId;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const onAnalyze = t3;
  let t4;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AccentHeading line1="Get Instant Feedback" />;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <>{t4}<WhyWeAsk items={UPLOAD_OUTCOMES.map(_temp2)} /><ProofStats /></>;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const t6 = signupRequest.pitchDeckUrl ? "Deck Loaded" : null;
  let t7;
  let t8;
  if ($[16] !== updateSignupRequest) {
    t7 = () => {
      updateSignupRequest({
        pitchDeckUrl: null,
        reportOutputAsJson: null,
        additionalFields: {
          deckFileName: null,
          deckStoredFileId: null,
          sampleDeckKey: null,
          aiActionId: null
        }
      });
    };
    t8 = (url, storedFileId_0) => {
      updateSignupRequest({
        pitchDeckUrl: url,
        reportOutputAsJson: null,
        additionalFields: {
          deckFileName: decodeURIComponent(url.split("/").pop() ?? ""),
          deckStoredFileId: storedFileId_0 ?? null,
          sampleDeckKey: null,
          aiActionId: null
        }
      });
    };
    $[16] = updateSignupRequest;
    $[17] = t7;
    $[18] = t8;
  } else {
    t7 = $[17];
    t8 = $[18];
  }
  let t9;
  if ($[19] !== fileLabel || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = <Panel><DeckUploadCard fileLabel={fileLabel} fileSubLabel={t6} onError={_temp3} onClear={t7} onUploaded={t8} /></Panel>;
    $[19] = fileLabel;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== error) {
    t10 = error && <Text color="red.fg" fontSize="sm" textAlign="center">{error}</Text>;
    $[24] = error;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const t11 = !hasDeck || currentUserLoading;
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <LuChevronRight />;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== busy || $[28] !== onAnalyze || $[29] !== t11) {
    t13 = <Button disabled={t11} fontWeight="bold" loading={busy} size="xl" variant="cta" width="full" onClick={onAnalyze}>Audit My Deck{t12}</Button>;
    $[27] = busy;
    $[28] = onAnalyze;
    $[29] = t11;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t10 || $[32] !== t13 || $[33] !== t9) {
    t14 = <DiagnosticColumns left={t5} right={<>{t9}{t10}{t13}</>} />;
    $[31] = t10;
    $[32] = t13;
    $[33] = t9;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  return t14;
};
function _temp() {
  tracker.funnelStep(0);
}
function _temp2(outcome) {
  return {
    icon: outcome.icon,
    text: outcome.text
  };
}
function _temp3(err) {
  return alert(err?.toString() || "Upload failed.");
}